import { render, staticRenderFns } from "./DialogDeleteTag.vue?vue&type=template&id=5a7478f1&scoped=true"
import script from "./DialogDeleteTag.vue?vue&type=script&lang=js"
export * from "./DialogDeleteTag.vue?vue&type=script&lang=js"
import style0 from "./DialogDeleteTag.vue?vue&type=style&index=0&id=5a7478f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7478f1",
  null
  
)

export default component.exports